<template>
  <div>
    <div class="with-margin">
      <router-link class="back" to="/"
        ><img alt="Back" src="@/assets/images/back.svg"
      /></router-link>
      <h1>Explore clariant</h1>
    </div>
    <video autoplay class="" loop muted playsinline height="450">
      <source src="@/assets/videos/about-clariant.mp4" type="video/mp4" />
    </video>
    <div class="with-margin tabs">
      <div class="flex flex-wrap justify-between">
        <a @click="change(1)" :class="{ selected: this.selected == 1 }"
          >The Leader</a
        >
        <a @click="change(2)" :class="{ selected: this.selected == 2 }"
          >Vision</a
        >
        <a @click="change(3)" :class="{ selected: this.selected == 3 }"
          >Mission</a
        >
        <a @click="change(4)" :class="{ selected: this.selected == 4 }"
          >Values</a
        >
      </div>
      <div class="tab-content">
        <div v-show="this.selected == 1" class="animated fadeInUp fast">
          <p>
            As one of the world’s leading specialty chemical companies, Clariant
            contributes to value creation with innovative and sustainable
            solutions for customers from many industries. Our portfolio is
            designed to meet very specific needs with as much precision as
            possible. At the same time, our research and development is focused
            on addressing the key trends of our time. These include energy
            efficiency, renewable raw materials, emission-free mobility, and
            conserving finite resources. Our business units are organized into
            three business areas: Care Chemicals, Natural Resources and
            Catalysis.
          </p>
        </div>
        <div v-show="this.selected == 2" class="animated fadeInUp fast">
          <p>
            We aim to be the global leading company for specialty chemicals and
            to stand out by above-average value creation for all of our
            stakeholders
          </p>
        </div>
        <div v-show="this.selected == 3" class="animated fadeInUp fast">
          <p>
            Our mission clearly expresses what is important to us and what we
            stand for –as a brand and as a company. We build leading positions
            in the businesses we are active in, and we adopt functional
            excellence as part of our culture. We create value through
            appreciating the needs of:
          </p>
          <p>
            – Our customers – by providing competitive and innovative
            solution<br />
            – Our employees – by adhering to our corporate values<br />
            – Our environment – by acting sustainably<br />
            – Our shareholders –by achieving above-average returns
          </p>
        </div>
        <div v-show="this.selected == 4" class="animated fadeInUp fast">
          <h3>Innovative & customized solutions</h3>
          <p>
            Our customers and their performance deserve our appreciation.
          </p>
          <p>
            It makes us proud to support them. At the same time, we are only
            successful if our customers enjoy success. That is why we strive for
            exceptional performance. We do everything to offer them innovative,
            customized, high-quality solutions.
          </p>
          <h3>PEOPLE</h3>
          <p>
            Dialogue is a foundation of our business in two key respects.
          </p>
          <p>
            First, we have to listen to exactly what our customers say if we are
            to determine their requirements. Furthermore, our success depends on
            an effective exchange between the people involved. Appreciation
            towards customer and colleagues, respect, transparency, and
            integrity help us to foster a spirit of dialogue.
          </p>
          <h3>PLANET</h3>
          <p>
            As a global specialty chemicals company, we are a player not only in
            the economy, but also in society and the environment. Our
            responsible approach to dealing with customers, staff, neighbors,
            resources, and the environment is both an ethical imperative and an
            expression of our appreciation. At the same time, ecological
            sustainability is a key factor for our success and that of our
            customers. By using sustainable, leading technologies, we aim to
            meet the most stringent standards and set new benchmarks in the
            industry.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.tab-content p {
  font-size: 22px;
  line-height: 30px;
  margin-top: 16px;
}

.tab-content h3 {
  margin-top: 24px;
  font-size: 24px;
  text-transform: uppercase;
  font-weight: bold;
}

.tab-content div {
  padding-bottom: 300px;
}

.tab-content {
  height: 830px;
  overflow-y: scroll;
}
</style>
<script>
export default {
  name: "about",
  data() {
    return {
      selected: 1
    };
  },
  methods: {
    change(index) {
      this.selected = index;
    }
  }
};
</script>
